/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Track_Assets_You_Plan_To_PuInputs */

const en_track_assets_you_plan_to_pu = /** @type {(inputs: Track_Assets_You_Plan_To_PuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track assets you plan to purchase or reference later.`)
};

const es_track_assets_you_plan_to_pu = /** @type {(inputs: Track_Assets_You_Plan_To_PuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz un seguimiento de los activos que planeas comprar o consultar más tarde.`)
};

const fr_track_assets_you_plan_to_pu = /** @type {(inputs: Track_Assets_You_Plan_To_PuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivez les biens que vous prévoyez d'acheter ou de consulter plus tard.`)
};

const de_track_assets_you_plan_to_pu = /** @type {(inputs: Track_Assets_You_Plan_To_PuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolge Assets, die du später kaufen oder aufrufen möchtest.`)
};

const id_track_assets_you_plan_to_pu = /** @type {(inputs: Track_Assets_You_Plan_To_PuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lacak aset yang Anda rencanakan untuk dibeli atau dirujuk nanti.`)
};

/** @type {(inputs: Track_Assets_You_Plan_To_PuInputs) => LocalizedString} */
const ja_track_assets_you_plan_to_pu = en_track_assets_you_plan_to_pu;

/** @type {(inputs: Track_Assets_You_Plan_To_PuInputs) => LocalizedString} */
const zh_track_assets_you_plan_to_pu = en_track_assets_you_plan_to_pu;

/** @type {(inputs: Track_Assets_You_Plan_To_PuInputs) => LocalizedString} */
const ar_track_assets_you_plan_to_pu = en_track_assets_you_plan_to_pu;

/** @type {(inputs: Track_Assets_You_Plan_To_PuInputs) => LocalizedString} */
const it_track_assets_you_plan_to_pu = en_track_assets_you_plan_to_pu;

/** @type {(inputs: Track_Assets_You_Plan_To_PuInputs) => LocalizedString} */
const ru_track_assets_you_plan_to_pu = en_track_assets_you_plan_to_pu;

/** @type {(inputs: Track_Assets_You_Plan_To_PuInputs) => LocalizedString} */
const pt_track_assets_you_plan_to_pu = en_track_assets_you_plan_to_pu;

/** @type {(inputs: Track_Assets_You_Plan_To_PuInputs) => LocalizedString} */
const ko_track_assets_you_plan_to_pu = en_track_assets_you_plan_to_pu;

/**
* | output |
* | --- |
* | "Track assets you plan to purchase or reference later." |
*
* @param {Track_Assets_You_Plan_To_PuInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const track_assets_you_plan_to_pu = /** @type {((inputs?: Track_Assets_You_Plan_To_PuInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Track_Assets_You_Plan_To_PuInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_track_assets_you_plan_to_pu(inputs)
	if (locale === "es") return es_track_assets_you_plan_to_pu(inputs)
	if (locale === "fr") return fr_track_assets_you_plan_to_pu(inputs)
	if (locale === "de") return de_track_assets_you_plan_to_pu(inputs)
	if (locale === "ja") return ja_track_assets_you_plan_to_pu(inputs)
	if (locale === "zh") return zh_track_assets_you_plan_to_pu(inputs)
	if (locale === "ar") return ar_track_assets_you_plan_to_pu(inputs)
	if (locale === "id") return id_track_assets_you_plan_to_pu(inputs)
	if (locale === "it") return it_track_assets_you_plan_to_pu(inputs)
	if (locale === "ru") return ru_track_assets_you_plan_to_pu(inputs)
	if (locale === "pt") return pt_track_assets_you_plan_to_pu(inputs)
	return ko_track_assets_you_plan_to_pu(inputs)
});